import { Container } from "react-bootstrap";
import GetAdvertisementElement from "../../common/getAdvertisementElement";
import "../../assets/css/scss/component/_advertisement.scss";
import "../../assets/css/scss/component/_tpProfileFirstPositionAdvertise.scss";
import { useSelector } from "react-redux";
import { IReduxStateData } from "../../interfaces/redux";
import { useEffect, useState } from "react";
import GetActiveDealAdvertisement from "../../common/getActiveDealAdvertisement";

export default function TpProfileFirstPositionAdvertise({ isTeam = false }) {
  const [profileAdvertisement, setProfileAdvertisement] = useState({});
  const globalState = useSelector((state: IReduxStateData) => state);
  const globalActiveAdv = useSelector(
    (state: IReduxStateData) => state.activeDealAdvertisement
  );
  useEffect(() => {
    if (globalActiveAdv) {
      const advertisementForPage = GetActiveDealAdvertisement(
        globalState,
        1,
        isTeam ? 2 : 3
      );
      setProfileAdvertisement(advertisementForPage || {});
    }
  }, [globalActiveAdv]);
  return (
    <>
      {Object.keys(profileAdvertisement).length ? (
        <section className="tp-first-advertise-section">
          <Container className="theme-light-white">
            <div className="row title">
              <div className="col-12">
                <div
                  className="advertisement-wrapper adv-image mb-3"
                  style={{ height: "400px", width: "100%" }}
                >
                  <GetAdvertisementElement {...profileAdvertisement} />
                </div>
              </div>
            </div>
          </Container>
        </section>
      ) : null}
    </>
  );
}
